<template>
  <q-layout>
    <q-header class="bg-primary text-white bg-grey-9">
      <q-toolbar>
        <q-btn
          flat
          dense
          round
          @click="leftDrawerOpen = !leftDrawerOpen"
          aria-label="Menu"
          icon="menu"
        />
        <q-toolbar-title class="flex items-center">
          <img src="/img/Logo_Original_Blanc_100px.png" class="q-mr-lg q-pb-sm">
          BarTradingX.com
        </q-toolbar-title>
        <q-btn-dropdown 
          icon="account_circle">
          <q-list>
            <q-item clickable v-close-popup @click="logout">
              <q-item-section>
                <q-item-label>Déconnexion</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </q-toolbar>
    </q-header>

    <q-drawer v-model="leftDrawerOpen" content-class="bg-grey-2">
      <q-list>
        <q-item-label header>Navigation</q-item-label>
        <q-item :to="{'name': 'dashboard'}" exact>
          <q-item-section avatar>
            <q-icon name="dashboard" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Dashboard</q-item-label>
          </q-item-section>
        </q-item>        
      </q-list>
    </q-drawer>

    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>
import { disconnectUser } from '~/services/api';
import { logout } from '~/services/user';

export default {
  name: "LayoutDefault",

  data() {
    return {
      leftDrawerOpen: false
    };
  },
  methods : {
    async logout () {
      if (this.$store.state.user != undefined){
        await logout({token: this.$store.state.user.refreshToken}).then((response) => {
          disconnectUser();
        });
      } else {
        disconnectUser();
      }
    }
  }
};
</script>
